import React, { useContext, useEffect, useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { AppContext } from "../../Contexts/AppContext";
import SuccessPopup from "../../Components/Popup/AlertPopup/SuccessPopup";
import ErrorPopup from "../Popup/AlertPopup/ErrorPopup";

const Hero = () => {
  const successPopupRef = useRef(null);
  const errorPopupRef = useRef(null);
  const form = useRef();
  const context = useContext(AppContext);

  const [currentBG, setCurrentBG] = useState("");
  const [currentText, setCurrentText] = useState("");
  const [formBG, setFormBG] = useState("");
  const [inputText, setInputText] = useState("");
  const [inputBG, setInputBG] = useState("");

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    setCurrentBG(
      context.isLight
        ? context.currentTheme["default"].bg
        : context.currentTheme["default"].dark_bg
    );
    setCurrentText(
      context.isLight
        ? context.currentTheme["default"].text
        : context.currentTheme["default"].dark_text
    );
    setFormBG(
      context.isLight
        ? context.currentTheme["default"].dark_bg
        : context.currentTheme["default"].dark_dropdown
    );
    setInputText(context.currentTheme["default"].dark_text);
    setInputBG(
      context.isLight
        ? context.currentTheme["default"].dark_dropdown
        : context.currentTheme["default"].dark_bg
    );
  }, [context]);

  const sendEmail = async (e) => {
    e.preventDefault();

    try {
      const result = await emailjs.sendForm(
        "common_space_22",
        "common_space",
        form.current,
        "6gIxaTBEchK5K_2Bl"
      );
      if (result.status === 200) {
        setSuccess("Your Message was successfully sent");
        successPopupRef.current.openTrigger();
        setFirstName("");
        setLastName("");
        setEmail("");
        setMessage("");
      } else {
        console.log(result);
      }
    } catch (error) {
      setError(error.text);
      errorPopupRef.current.openTrigger();
    }
  };

  return (
    <div
      className="relative w-screen transition-all duration-500"
      style={{ backgroundColor: currentBG, color: currentText }}
    >
      <div className="m-auto flex w-3/4 flex-col items-center justify-center pt-10 ss:w-2/3 lg:w-1/2">
        <h1 className="mb-2 text-3xl font-bold ss:mb-4 ss:text-5xl">
          Contact Us
        </h1>
        <p className="text-center text-sm font-thin ss:w-3/4 ss:text-base">
          Got a technical issue? Want to send feedback about a beta feature?
          Need details about our Business plan? Let us know.
        </p>
        <form
          ref={form}
          className="m-5 flex w-full flex-col items-stretch justify-center rounded-sm p-2 shadow-[0_0px_6px_0px_#000a] transition-all duration-500 ss:rounded-lg ss:p-3 ss:shadow-[0_0px_10px_0px_#000a] md:p-5"
          style={{ backgroundColor: formBG, color: inputText }}
          onSubmit={sendEmail}
        >
          <div className="flex flex-col sm:mb-3 sm:flex-row md:mb-5">
            <div className="mb-2 flex w-full flex-col ss:mb-3 sm:mb-0 sm:mr-1 sm:w-1/2 md:mr-2">
              <label htmlFor="user_first_name" className="mb-1 md:mb-2">
                First Name<span className="text-red-500">*</span>
              </label>
              <input
                id="user_first_name"
                required
                type="text"
                name="user_first_name"
                placeholder="Joe"
                value={firstName}
                className="rounded p-2 text-sm outline-none md:p-4 md:text-base"
                style={{ backgroundColor: inputBG }}
                onChange={(e) => setFirstName(e.target.value)}
              />
            </div>
            <div className="mb-2 flex w-full flex-col ss:mb-3 sm:mb-0 sm:ml-1 sm:w-1/2 md:ml-2">
              <label htmlFor="user_last_name" className="mb-1 md:mb-2">
                Last Name<span className="text-red-500">*</span>
              </label>
              <input
                id="user_last_name"
                required
                type="text"
                name="user_last_name"
                placeholder="Musk"
                value={lastName}
                className="rounded p-2 text-sm outline-none md:p-4 md:text-base"
                style={{ backgroundColor: inputBG }}
                onChange={(e) => setLastName(e.target.value)}
              />
            </div>
          </div>
          <label htmlFor="user_email" className="mb-1 md:mb-2">
            Email<span className="text-red-500">*</span>
          </label>
          <input
            id="user_email"
            required
            type="email"
            name="user_email"
            placeholder="joe@example.com"
            value={email}
            className="mb-2 rounded p-2 text-sm outline-none ss:mb-3 md:mb-5 md:p-4 md:text-base"
            style={{ backgroundColor: inputBG }}
            onChange={(e) => setEmail(e.target.value)}
          />
          <label htmlFor="message" className="mb-1 md:mb-2">
            Message<span className="text-red-500">*</span>
          </label>
          <textarea
            id="message"
            required
            name="message"
            placeholder="Your Message"
            value={message}
            className="mb-2 resize-none rounded p-2 text-sm outline-none ss:mb-3 md:mb-5 md:p-4 md:text-base"
            style={{ backgroundColor: inputBG }}
            onChange={(e) => setMessage(e.target.value)}
          />
          <p className="mb-4 text-xs leading-tight text-gray-400 ss:mb-8 ss:text-sm md:mb-10">
            By submitting this form which going to include information about
            your offer, you'll receive <b>an email</b> which contains that the
            offer will be reviewed and later on we'll let you know{" "}
            <b>our decision</b>. Thank you.
          </p>
          <input
            type="submit"
            className="w-fit cursor-pointer rounded bg-white px-6 py-1 text-sm transition-all ss:rounded-lg ss:px-8 ss:text-base md:py-2 md:px-10 md:text-lg"
            style={{
              backgroundColor: inputText,
              color: inputBG,
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = inputBG;
              e.target.style.color = inputText;
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = inputText;
              e.target.style.color = inputBG;
            }}
            value="SEND"
          />
        </form>
      </div>
      <SuccessPopup ref={successPopupRef} message={success} />
      <ErrorPopup ref={errorPopupRef} message={error} />
    </div>
  );
};

export default Hero;
